// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__216o7","type":"styles_type__3-Rmp","choices":"styles_choices__2Kd71"};